import { Text } from '@kanda-libs/ks-design-library';
import { useMemo } from 'react';

export interface ExpansionItemProps {
  text: string;
  isActive: boolean;
  isPassed: boolean;
  isLoading: boolean;
}

const ExpansionItem: React.FunctionComponent<ExpansionItemProps> = function ({
  text,
  isActive,
  isPassed,
  isLoading,
}) {
  const circleClassName = useMemo(
    () =>
      [
        'absolute right-3.25 top-1.5 w-1.5 min-w-1.5 h-1.5 min-h-1.5 rounded-full',
        isActive || isPassed ? 'bg-neutral-900' : 'bg-neutral-500',
      ].join(' '),
    [isActive, isPassed],
  );

  return (
    <div className="flex flex-col">
      <div className="w-8 h-1 mr-auto bg-neutral-300" />
      <div className="flex flex-row gap-x-6">
        <div className="relative w-8 bg-neutral-300">
          <div className={circleClassName} />
        </div>
        <Text
          className="text-14-22-em text-neutral-900"
          isLoading={isLoading}
          text={text}
        />
      </div>
      <div className="w-8 h-1 mr-auto bg-neutral-300" />
    </div>
  );
};

export default ExpansionItem;
